import { IContentItem } from '../interfaces';

export class ContentItemsRequest {
    userId: number;
    channelId: number;
    convoId: number;
    contentItems: IContentItem[];
}
